/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../../types/enums.js";

export const WorkflowRunStatus = {
  NotStarted: "not-started",
  Running: "running",
  Uploading: "uploading",
  Success: "success",
  Failed: "failed",
  Started: "started",
  Queued: "queued",
  Timeout: "timeout",
  Cancelled: "cancelled",
} as const;
export type WorkflowRunStatus = ClosedEnum<typeof WorkflowRunStatus>;

/** @internal */
export const WorkflowRunStatus$inboundSchema: z.ZodNativeEnum<
  typeof WorkflowRunStatus
> = z.nativeEnum(WorkflowRunStatus);

/** @internal */
export const WorkflowRunStatus$outboundSchema: z.ZodNativeEnum<
  typeof WorkflowRunStatus
> = WorkflowRunStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace WorkflowRunStatus$ {
  /** @deprecated use `WorkflowRunStatus$inboundSchema` instead. */
  export const inboundSchema = WorkflowRunStatus$inboundSchema;
  /** @deprecated use `WorkflowRunStatus$outboundSchema` instead. */
  export const outboundSchema = WorkflowRunStatus$outboundSchema;
}
